// Simple offline queue for POST requests (sales/attendance/consumables/etc.)
import { api } from "@/lib/api";
import { toast } from "sonner";

const QUEUE_KEY = "bb_offline_queue";

const load = () => {
  try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]"); } catch { return []; }
};
const save = (arr) => localStorage.setItem(QUEUE_KEY, JSON.stringify(arr));

export const queueRequest = (item) => {
  const arr = load(); arr.push({ ...item, ts: Date.now() }); save(arr);
};

export const queueSize = () => load().length;

export const flushQueue = async () => {
  const arr = load();
  if (!arr.length) return { flushed: 0 };
  const remaining = [];
  let flushed = 0;
  for (const item of arr) {
    try {
      await api.request({ url: item.url, method: item.method || "POST", data: item.data });
      flushed++;
    } catch (e) {
      // If it's a 4xx (business error), drop; if network/5xx keep.
      const status = e.response?.status;
      if (status && status >= 400 && status < 500) continue;
      remaining.push(item);
    }
  }
  save(remaining);
  return { flushed, remaining: remaining.length };
};

// Try to flush when back online
export const initSync = () => {
  const attempt = async () => {
    if (!navigator.onLine) return;
    const size = queueSize();
    if (!size) return;
    const { flushed } = await flushQueue();
    if (flushed) toast.success(`Synced ${flushed} offline entries`);
  };
  window.addEventListener("online", attempt);
  attempt();
};
